export const mobileMenu = () => {
	const nav = document.getElementById('site-navigation');
	const button = nav?.querySelector('button');
	const menu = nav?.querySelector('ul');

	// Hide menu toggle button if menu is empty and return early.
	if (!nav || !button || !menu) {
		button?.classList.add('hidden');
		return;
	}

	if (!menu.classList.contains('nav-menu')) {
		menu.classList.add('nav-menu');
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener('click', () => {
		nav.classList.toggle('toggled');
		//toggle menu-shown class on body
		document.body.classList.toggle('menu-shown');

		const isExpanded = button.getAttribute('aria-expanded') === 'true';

		button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
	});

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener('click', (event) => {
		const isClickInside = nav.contains(event.target);

		if (!isClickInside) {
			nav.classList.remove('toggled');
			button.setAttribute('aria-expanded', 'false');
		}
	});

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName('a');

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');
};

function handleBlurFocus(event) {
	let currentElement = event.currentTarget;
	// Move up through the ancestors of the current link until we hit .nav-menu.
	while (currentElement && !currentElement.classList.contains('nav-menu')) {
		// On li elements toggle the class .focus.
		if ('li' === currentElement.tagName.toLowerCase()) {
			currentElement.classList.toggle('focus');
		}
		currentElement = currentElement.parentNode;
	}
}

function handleTouchFocus(event) {
	event.preventDefault();

	const menuItem = event.currentTarget.parentNode;

	for (const link of menuItem.parentNode.children) {
		if (menuItem !== link) {
			link.classList.remove('focus');
		}
	}
	menuItem.classList.toggle('focus');
}
